"use client";
import { jsx as t, jsxs as o } from "react/jsx-runtime";
import c from "clsx";
import { Box as s } from "../base/Base.js";
import '../../assets/Comments.css';const _ = "_set_17jvz_1", i = "_inner_17jvz_12", l = "_comment_17jvz_30", p = "_username_17jvz_39", v = "_star_17jvz_47", d = "__rate_17jvz_51", j = "_text_17jvz_55", e = {
  set: _,
  inner: i,
  comment: l,
  username: p,
  star: v,
  _rate: d,
  text: j
}, N = ({ children: a }) => /* @__PURE__ */ t(s, { className: e.set, children: /* @__PURE__ */ t(s, { gap: 12, row: !0, className: e.inner, children: a }) });
N.displayName = "CommentSet";
const u = ({ username: a, rating: n, text: m }) => /* @__PURE__ */ o(s, { gap: 12, className: e.comment, children: [
  /* @__PURE__ */ t("div", { className: e.username, children: a }),
  /* @__PURE__ */ t(s, { gap: 0, row: !0, className: e.rating, children: [...Array(5)].map((x, r) => /* @__PURE__ */ t(
    "div",
    {
      className: c("material-icons", e.star, e[r], {
        [e._rate]: r < n
      }),
      "data-icon": "star"
    },
    r
  )) }),
  /* @__PURE__ */ t("div", { className: e.text, children: m })
] });
u.displayName = "Comment";
export {
  u as Comment,
  N as CommentSet
};
